<div class="slider-container">
  <label *ngIf="label" class="slider-label">{{ label }}</label>
  <div class="slider-controls">
    <button 
      *ngIf="showButtons"
      class="slider-button"
      (click)="decrement()"
      [disabled]="value !== null && value <= min"
      aria-label="Decrease">
      -
    </button>
    <div class="slider-wrapper">
      <input
        type="range"
        class="slider-input"
        [value]="value"
        [min]="min"
        [max]="max"
        [step]="step"
        (input)="handleInputChange($event)"
        [attr.aria-label]="label"
        [attr.aria-valuenow]="value"
        [attr.aria-valuemin]="min"
        [attr.aria-valuemax]="max">
      <div *ngIf="showTicks" class="slider-ticks">
        <div *ngFor="let tick of ticks" class="tick" [style.left.%]="((tick - min) / (max - min)) * 100">
          <span class="tick-label">{{ tick }}{{ unit }}</span>
        </div>
      </div>
    </div>
    <button 
      *ngIf="showButtons"
      class="slider-button"
      (click)="increment()"
      [disabled]="value !== null && value >= max"
      aria-label="Increase">
      +
    </button>
  </div>
  <div class="slider-value">{{ displayValue }}</div>
</div>